import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DocumentService } from "../../service/document.service";
import { NgForm } from "@angular/forms";
import { SelectItem } from "primeng/api";
import { Message } from "primeng/components/common/api";
import { MessageService } from "primeng/components/common/messageservice";
import { Router } from "@angular/router";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { AppSettings } from "../../shared/AppSettings";
import { OrderService } from "../../service/order.service";
import { UserService } from "../../shared/user.service";

@Component({
  selector: "new-document-profit",
  templateUrl: "./new-document-profit.component.html",
  styleUrls: ["./new-document-profit.component.css"],
})
export class NewDocumentProfitComponent implements OnInit {
  readonly rootUrl = AppSettings.webApiURL;

  message: string = "";
  msgs: Message[] = [];

  suppliers: any = [];
  selectedSuppliers: any = []; //any[] = [];
  filteredSuppliers: any = []; //any[] = [];
  content: any;
  documentName: any;
  documentDate: Date;
  documentNote: any;
  progressValue: any;
  attachments: any = [];
  isCodeRequired: boolean = false;
  code: string = "";
  documentList: any = [];
  cols: any[];

  profitOrderNum: string;
  SupplierName: string;
  SupplierNum: string;
  userDetails: any = null;
  order: any;

  showDocumentPreviewDialog: boolean = false;
  currentDocumentDetails: any;

  inputOrderId: string;

  orderNotFound: boolean = false;

  constructor(
    public route: ActivatedRoute,
    public dataService: DocumentService,
    public router: Router,
    private userService: UserService,
    private orderService: OrderService
  ) {
    //, private orderService: OrderService) {
  }

  // ngOnInit() {
  //   this.userService.getUserClaims().subscribe((result: any) => {
  //     this.userDetails = result;

  //     this.dataService.InitDocument().subscribe(result => {
  //     },
  //     (err: HttpErrorResponse) => {
  //       this.showMessage('error', '', 'תקלה באתחול');
  //     });

  //     this.profitOrderNum = this.route.snapshot.paramMap.get('id');
  //     if (this.profitOrderNum) {
  //       if (this.userDetails && this.userDetails.ClientRoleCustomer) {

  //         this.getCustomerOrders();

  //         this.dataService.getDocumentProfitList(this.profitOrderNum).subscribe(result => {
  //           this.documentList = result;
  //         },
  //           (err: HttpErrorResponse) => {
  //             this.showMessage('error', '', 'תקלה באתחול רשימת מסמכים');
  //           });
  //       }
  //       else {
  //         this.userDetails = null;
  //         this.showMessage('error', '', 'Access denied');
  //       }
  //     } else {
  //       this.userDetails = null;
  //       this.showMessage('error', '', 'Access denied');
  //     }

  //   }, (err: HttpErrorResponse) => {
  //     this.userDetails = null;
  //     this.showMessage('error', '', 'Access denied');
  //   });

  //   //this.dataService.getSuppliers().subscribe(result => {     //(result: any) => {
  //   //  this.suppliers = result;

  //   //},
  //   //(err: HttpErrorResponse) => {
  //   //  this.showMessage('error', '', 'תקלה באתחול ספקים');
  //   //  });

  //   this.cols = [
  //     // { field: 'DocumentId', header: '' },
  //     { field: 'DocumentName', header: 'שם מסמך' },
  //     { field: 'DocumentNote', header: 'תאור' },
  //     { field: 'DocumentDate', header: 'תאריך' },
  //     { field: 'UserFullName', header: 'גורם הוספה' },
  //     //{ field: 'UserName', header: 'יוזר גורם הוספה' },
  //     //{ field: 'SupplierName', header: 'שם ספק' },
  //    //{ field: 'DocumentLink', header: 'הצג קובץ' }
  //   ];

  //   this.initMessage();
  // }

  ngOnInit() {
    this.userService.getUserClaims().subscribe(
      (result: any) => {
        this.userDetails = result;

        this.dataService.InitDocument().subscribe(
          () => {},
          (err: HttpErrorResponse) => {
            this.showMessage("error", "", "תקלה באתחול");
          }
        );

        this.profitOrderNum = this.route.snapshot.paramMap.get("id");

        if (this.profitOrderNum) {
          if (this.userDetails && this.userDetails.ClientRoleCustomer) {
            this.getCustomerOrders();

            this.dataService
              .getDocumentProfitList(this.profitOrderNum)
              .subscribe(
                (result) => {
                  this.documentList = result;
                },
                (err: HttpErrorResponse) => {
                  this.showMessage("error", "", "תקלה באתחול רשימת מסמכים");
                }
              );
          } else {
            this.showMessage("error", "", "Access denied");
          }
        }

        this.cols = [
          { field: "DocumentName", header: "שם מסמך" },
          { field: "DocumentNote", header: "תאור" },
          { field: "DocumentDate", header: "תאריך" },
          { field: "UserFullName", header: "גורם הוספה" },
        ];

        this.initMessage();
      },
      (err: HttpErrorResponse) => {
        this.showMessage("error", "", "Access denied");
      }
    );
  }

  searchSuppliers(event) {
    let query = event.query;
    this.filteredSuppliers = this.filterSuppliers(query, this.suppliers);
  }

  getCustomerOrders() {
    this.orderNotFound = false; // reset

    this.orderService
      .getOrderByOrderNumberDetails(this.profitOrderNum)
      .subscribe(
        (result: any) => {
          // Check if the order is effectively "not found"
          if (!result || result.OrderId === 0 || result.OrderNumber === null) {
            this.orderNotFound = true;
            this.order = null;
            this.showMessage("info", "", "ההזמנה לא נמצאה");
            return;
          }

          this.order = result;
          this.SupplierName = this.order.SupplierName;
          this.SupplierNum = this.order.SupplierNum;
        },
        (err: HttpErrorResponse) => {
          let errMessage =
            err.error && err.error.ExceptionMessage
              ? err.error.ExceptionMessage
              : "תקלה בקבלת נתוני הזמנה ";
          this.showMessage("error", "", errMessage);
        }
      );
  }

  initMessage() {
    this.selectedSuppliers = [];
    this.content = "";
    this.isCodeRequired = false;
    this.code = "";
    this.attachments = [];
    this.documentName = "";
    this.documentDate = null;
    this.documentNote = "";
  }

  onSubmit(f: NgForm) {
    if (f.valid) {
    }
  }

  private onBeforeSend(event) {
    this.progressValue = "";
    let userToken = localStorage.getItem("userToken");
    // event.xhr.open("POST", 'http://localhost:34567/api/ComposeMessageApi/upload', true);
    event.xhr.setRequestHeader("Authorization", "Bearer " + userToken);
    event.xhr.withCredentials = true;
  }

  onProgress(event) {
    if (event.originalEvent.loaded !== 0) {
      this.progressValue =
        Math.round(
          (event.originalEvent.loaded / event.originalEvent.total) * 100
        ).toString() + "%";
    }
  }

  onError(event: any) {
    this.progressValue = "";
    console.log(event);
    this.showMessage("error", "", "תקלה בהעלאת קובץ");
  }

  onUpload(event) {
    this.progressValue = "";
    this.refreshAttachments();
  }

  refreshAttachments() {
    this.dataService.getAttachments().subscribe(
      (result) => {
        this.attachments = result;
      },
      (err: HttpErrorResponse) => {
        this.showMessage("error", "", "קלה באיחזור קבצים");
      }
    );
  }

  removeAttachment(attachment) {
    this.dataService.removeAttachment(attachment.Name).subscribe(
      (result) => {
        this.refreshAttachments();
      },
      (err: HttpErrorResponse) => {
        this.showMessage("error", "", "קלה במחיקת קובץ");
      }
    );
  }

  saveDocument() {
    //this.selectedSuppliers = [];
    //if (this.filteredSuppliers !== null && (this.filteredSuppliers.length === undefined || this.filteredSuppliers.length > 0)) {
    //  this.selectedSuppliers.push(this.filteredSuppliers);
    //}
    let valid = true;
    //if (this.selectedSuppliers == null || this.selectedSuppliers.length == 0) {
    //  valid = false;
    //  this.showMessage('error', '', 'נא לבחור ספק');
    //}
    if (this.documentName == null || this.documentName.length == 0) {
      valid = false;
      this.showMessage("error", "", "נא לרשום שם מסמך");
    }
    if (this.documentDate == null) {
      valid = false;
      this.showMessage("error", "", "נא לבחור תאריך מסמך");
    }
    if (this.attachments == null || this.attachments.length == 0) {
      valid = false;
      this.showMessage("error", "", "נא לצרף קובץ");
    }
    //if (this.isCodeRequired && this.code=='') {
    //  valid = false;
    //  this.showMessage('error', '', 'נא להזין קוד כאשר דרישת קוד מסומנת');
    //}
    //if (this.content && this.content.length > 4000) {
    //  valid = false;
    //  this.showMessage('error', '', 'תוכן ההודעה לא יכול לעלות מעל 4000 תווים ' + '(תוכן נוכחי - ' + this.content.length.toString() + 'תווים )');
    //}
    if (valid) {
      let documentData = {
        ProfitOrderNum: this.profitOrderNum,
        DocumentName: this.documentName,
        //isCodeRequired: this.isCodeRequired,
        //Code: this.isCodeRequired ? this.code : ''};
        DocumentNote: this.documentNote,
        DocumentDate: new Date(
          Date.UTC(
            this.documentDate.getFullYear(),
            this.documentDate.getMonth(),
            this.documentDate.getDate()
          )
        ),
      };
      this.dataService.saveDocumentProfit(documentData).subscribe(
        (result) => {
          this.showMessage("success", "", "מסמך נשמר");
          this.ngOnInit();
        },
        (err: HttpErrorResponse) => {
          this.showMessage("error", "", "תקלה באתחול ספקים");
        }
      );
    }
  }

  filterSuppliers(query, suppliers: any[]): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < suppliers.length; i++) {
      let supplier = suppliers[i];
      if (
        supplier.Name.toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
        supplier.EMail.toLowerCase().indexOf(query.toLowerCase()) >= 0
      ) {
        filtered.push(supplier);
      }
    }
    return filtered;
  }

  downloadAttachment(documentId, DocumentLink) {
    let m = this.route.snapshot.queryParamMap.get("m");
    let g = this.route.snapshot.queryParamMap.get("g");

    //let vm = { m: m, g: g, c: this.data.Code, f: attachment.Name };

    try {
      this.dataService.downloadAttachment(documentId).subscribe(
        (result) => {
          window.URL.createObjectURL(
            new Blob([result], { type: "application/octet-stream" })
          );
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(result, DocumentLink);
          }
          let url = window.URL.createObjectURL(result);
          let link = document.createElement("a");
          link.href = url;
          link.download = `${DocumentLink}`;
          link.click();
        },
        (err: HttpErrorResponse) => {
          this.showMessage("error", "", "תקלה בהורדת קובץ");
        }
      );
    } catch (error) {
      this.showMessage("error", "", "תקלה בהורדת הקובץ");
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({
      severity: type,
      summary: summaryMessage,
      detail: message,
    });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({
      severity: "success",
      summary: "",
      detail: " העדכון נשמר בהצלחה",
    });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: "error", summary: "", detail: " שגיאה בעדכון" });
  }

  showFile(document) {
    this.currentDocumentDetails = document;
    this.showDocumentPreviewDialog = true;
  }

  loadDocumentById() {
    if (!this.inputOrderId) {
      this.showMessage("error", "", "אנא הזן מספר הזמנה");
      return;
    }

    // Navigate to the same component but with the ID in the route
    this.router.navigate(["/new-document-profit", this.inputOrderId]);
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/document/new-document-profit/new-document-profit.component.ts